export default "/images/1fdfb137c8b685800fe3d93c1bfb28d2.avif";